module.exports = __webpack_public_path__ + "media/images/introduction-button-img-152c96d87edd86796c615149148b0906.png";